import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',
    title: getDefaultValue(
      searchParams.get('title'),
      'Присылайте поздравления'
    ),

    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),

    startFrom: searchParams.get('startFrom')
      ? parseInt(searchParams.get('startFrom') || '')
      : 1,
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 7000,
    durationF2: searchParams.get('durationF2')
      ? parseInt(searchParams.get('durationF2') || '')
      : 4000,
    carousel: searchParams.get('carousel') || '1',
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 10,
    titleFontSize: searchParams.get('titleFontSize') || '8.5',
    sizeQR: searchParams.get('sizeQR') || '82.5',
    paddingQR: searchParams.get('paddingQR') || '0',

    // phoneNumber,
    // // sizeLogo: searchParams.get('sizeLogo') || '39.6',
    // logo: searchParams.get('logo') || null,
    // socials: searchParams.get('socials'),
    // bgVideo: searchParams.get('bgVideo') || '1',
    // bgPoster: searchParams.get('bgPoster') || null,
    // phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '5',
  };
};
